import { Controller } from "web-ui/controller"
import { morphdomHold } from "web-ui/morphdom/hold"
import * as Log from "web-ui/log"

// Connects to data-controller="field-preview"
export default class extends Controller {
  static values = {
    sourceId: String,
    placeholder: String
  }

  static targets = [ "destination" ]

  connect() {
    this.debug("Connect", { sourceId: this.sourceIdValue })

    const sourceTarget = this.sourceTarget()
    sourceTarget.addEventListener("input", this.onInput)
    sourceTarget.addEventListener("focus", this.onFocus)
    sourceTarget.addEventListener("blur", this.onBlur)
  }

  disconnect() {
    this.debug("Disconnect")

    const sourceTarget = this.sourceTarget()
    if (sourceTarget !== null) {
      sourceTarget.removeEventListener("input", this.onInput)
      sourceTarget.removeEventListener("focus", this.onFocus)
      sourceTarget.removeEventListener("blur", this.onBlur)
    }

    this.releaseHold()
  }

  onInput = (event) => {
    const value = event.target.value.trim()

    if (value === null || value === "") {
      if (this.hasPlaceholderValue) {
        this.updatePreview(this.placeholderValue)
      } else {
        this.hidePreview()
        this.updatePreview(value)
      }
    } else {
      this.updatePreview(value)
      this.showPreview()
    }
  }

  onFocus = () => {
    this.debug("Focus")
    this.hold ??= morphdomHold(this.element)
  }

  onBlur = () => {
    this.debug("Blur")
    this.releaseHold()
  }

  releaseHold() {
    if (this.hold) {
      this.hold.release()
      this.hold = null
    }
  }

  showPreview() {
    this.element.hidden = false
  }

  hidePreview() {
    this.element.hidden = true
  }

  updatePreview(text) {
    // We are setting the element's content using `textContent`
    // to ensure the application is not vulnerable to HTML injection
    // - Nick, Scott A, Thu Feb 15 2024
    this.destinationTarget.textContent = text
  }

  sourceTarget() {
    return document.getElementById(this.sourceIdValue)
  }

  debug(message, data) {
    Log.debug("Field Preview - " + message, data)
  }
}
